// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { globalMessagesInitialState } from '../store/initialState';
import { clone } from './helper';
import { combineReducers } from 'redux';
import { DISPLAY_GLOBAL_MESSAGE, HIDE_GLOBAL_MESSAGE } from '../actions/globalMessage.js';

const reducer = (state = globalMessagesInitialState, action) => {
  switch (action.type) {
    case DISPLAY_GLOBAL_MESSAGE:
      return objectAssign({}, state, {
        messageData: action.data,
      });
    case HIDE_GLOBAL_MESSAGE:
      return objectAssign({}, state, {
        messageData: null,
      });
    default:
      return state;
  }
};
export default reducer;
